<template>
  <ParseForm :formParams='formParams' :reMountPage='reMountPage' ref='bus'></ParseForm>
</template>

<script>
import ParseForm from '../../util/parseForm/ParseForm';

export default {
  name: 'U_BaseBusiness',
  components: {
    ParseForm
  },
  props: [
    'formParams',
    'reMountPage'
  ],
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    reMount(data = null) {
      this.$refs.bus.reMount(data);
    }
  },
};
</script>

<style scoped>

</style>
